var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainMarkGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5931 13.1996C57.5931 11.2114 55.9813 9.59961 53.9931 9.59961H37.1934C35.2052 9.59961 33.5934 11.2114 33.5934 13.1996V29.5627C33.5934 30.5175 33.2141 31.4331 32.539 32.1083L32.1021 32.5452C31.427 33.2203 30.5113 33.5996 29.5566 33.5996H13.1937C11.2055 33.5996 9.59375 35.2114 9.59375 37.1996L9.59375 82.7996C9.59375 84.7878 11.2055 86.3996 13.1937 86.3996H29.5565C30.5113 86.3996 31.427 86.7789 32.1021 87.454L32.539 87.8909C33.2141 88.5661 33.5934 89.4817 33.5934 90.4365L33.5934 106.8C33.5934 108.788 35.2052 110.4 37.1934 110.4H82.7927C84.7809 110.4 86.3927 108.788 86.3927 106.8V90.4362C86.3927 89.4814 86.772 88.5657 87.4471 87.8906L87.8837 87.454C88.5588 86.7789 89.4745 86.3996 90.4292 86.3996H106.792C108.781 86.3996 110.392 84.7878 110.392 82.7996V65.9996C110.392 64.0114 108.781 62.3996 106.792 62.3996H89.9926C88.0044 62.3996 86.3927 64.0114 86.3927 65.9996V82.3627C86.3927 83.3175 86.0134 84.2331 85.3383 84.9083L84.9014 85.3452C84.2262 86.0203 83.3106 86.3996 82.3558 86.3996H37.63C36.6752 86.3996 35.7595 86.0203 35.0844 85.3452L34.6478 84.9086C33.9727 84.2335 33.5934 83.3178 33.5934 82.363L33.5934 37.6362C33.5934 36.6814 33.9727 35.7657 34.6478 35.0906L35.0844 34.654C35.7595 33.9789 36.6752 33.5996 37.6299 33.5996H53.9931C55.9813 33.5996 57.5931 31.9878 57.5931 29.9996V13.1996Z",
    fill: "url(#paint0_linear_4237_34799)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.794 9.59961C108.782 9.59961 110.394 11.2114 110.394 13.1996V44.3996C110.394 46.3878 108.782 47.9996 106.794 47.9996H76.031C75.0762 47.9996 74.1605 48.3789 73.4854 49.054L73.0486 49.4908C72.3735 50.1659 71.9942 51.0816 71.9942 52.0364V68.3996C71.9942 70.3878 70.3825 71.9996 68.3943 71.9996H51.5945C49.6063 71.9996 47.9946 70.3878 47.9946 68.3996V51.5996C47.9946 49.6114 49.6063 47.9996 51.5945 47.9996H67.9576C68.9123 47.9996 69.828 47.6203 70.5031 46.9452L70.9398 46.5084C71.615 45.8333 71.9942 44.9176 71.9942 43.9629V13.1996C71.9942 11.2114 73.606 9.59961 75.5942 9.59961H106.794Z",
    fill: "url(#paint1_linear_4237_34799)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4237_34799",
    x1: 68.5784,
    y1: -44.6773,
    x2: -38.5446,
    y2: 61.1488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A192EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5547EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4237_34799",
    x1: 68.5784,
    y1: -44.6773,
    x2: -38.5446,
    y2: 61.1488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A192EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5547EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainMarkGradient);
export default __webpack_public_path__ + "static/media/main-mark-gradient.e1e6c417d5095f43a9aaf3a1deb9d276.svg";
export { ForwardRef as ReactComponent };